import React, { Component } from 'react';
import './TopBar.css';
import tr from '../../../libs/tr';

class TopBar extends Component {
  render() {
    return  <div className="sn_topbar_rail">
              <div className="container">
                <div className="row">

                  <div className="col d-flex justify-content-center">
                    <div className={'sn_topbar_step' + (this.props.step === '1' ? " _active" : '')}>
                      <div className="sn_topbar_step_circle">
                        1
                      </div>
                      <div className="sn_topbar_step_label">
                      {tr.t("InsertYourData")}
                      </div>
                    </div>
                  </div>

                  <div className="col d-flex justify-content-center">
                    <div className={'sn_topbar_step' + (this.props.step === '2' ? " _active" : '')}>
                      <div className="sn_topbar_step_circle">
                        2
                      </div>
                      <div className="sn_topbar_step_label">
                      {tr.t("ConfigureYourKeycard")}
                      </div>
                    </div>

                  </div>
                  <div className="col d-flex justify-content-center">
                    <div className={'sn_topbar_step' + (this.props.step === '3' ? " _active" : '')}>
                      <div className="sn_topbar_step_circle">
                        3
                      </div>
                      <div className="sn_topbar_step_label">
                        {tr.t("PaymentDetails")} 

                      </div>
                    </div>
                  </div>
                  <div className="col d-flex justify-content-center">
                    <div className={'sn_topbar_step' + (this.props.step === '4' ? " _active" : '')}>
                      <div className="sn_topbar_step_circle">
                        4
                      </div>
                      <div className="sn_topbar_step_label">
                        {tr.t("StartSkiing")}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>;
  }
}

export default TopBar;


// WEBPACK FOOTER //
// ./src/assets/components/topbar/TopBar.js